import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=637d3cf6&"
import script from "./AudioPlayer.vue?vue&type=script&lang=js&"
export * from "./AudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "plyr/dist/plyr.css?vue&type=style&index=0&lang=css&"
import style1 from "./AudioPlayer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports